import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { ConnectionResponse, ConnectionStatus, IntegrationMarketingResponse } from '@vendasta/platform-integrations';
import { User } from '@vendasta/iamv2';
import { PlatformIntegrationsI18nModule } from '@galaxy/platform-integrations/shared';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { UserAction } from '../const';

@Component({
  selector: 'platform-integration-card',
  templateUrl: './integration-card.component.html',
  styleUrls: ['./integration-card.component.scss'],
  imports: [
    CommonModule,
    GalaxySnackbarModule,
    GalaxyBadgeModule,
    TranslateModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PlatformIntegrationsI18nModule,
    RouterModule,
    GalaxyAvatarModule,
    GalaxyPipesModule,
  ],
})
export class IntegrationCardComponent {
  @Input() tab: UserAction = UserAction.BROWSE;
  @Input() integration?: IntegrationMarketingResponse;
  @Input() connection?: ConnectionResponse;
  @Input() user?: User;
  private readonly router = inject(Router);
  protected readonly connectionStatus = ConnectionStatus;
  protected readonly userAction = UserAction;

  //Used to get path of URL to make it generic for Both PC and BusinessApp
  // Example, if URL is https://vendasta-university-dot-vbc-demo.appspot.com/account/location/AG-JP5VN52N7P/settings/integrations
  // we extract only account/location/AG-JP5VN52N7P/settings , which used to redirect.
  getCurrentPath(): string {
    let path = window.location.pathname;
    const lastIndex = path.indexOf('/integrations');
    path = path.substring(0, lastIndex);
    return path;
  }

  handleImageError(event: Event) {
    const element = event.target as HTMLInputElement;
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    element.style.backgroundColor = '#9e9e9e';
  }

  getProfileImageUrl(connection?: ConnectionResponse) {
    return connection?.customFields?.find((field) => field.label === 'profileImageURL')?.value;
  }

  getStatusLastUpdatedDate(): Date | string | number {
    return this.connection?.statusLastUpdated ? new Date(this.connection.statusLastUpdated) : '';
  }

  redirect() {
    switch (this.tab) {
      case UserAction.BROWSE:
        this.openMarketingPage();
        break;
      case UserAction.MANAGE:
        this.openConfigPage();
        break;
      default:
        this.openMarketingPage();
    }
  }

  openMarketingPage() {
    const url = this.getCurrentPath() + '/integrations/' + this.integration?.integrationId;
    this.router.navigate([url]);
  }

  openConfigPage() {
    const url = this.getCurrentPath() + '/integrations/config/' + this.connection?.connectionId;
    this.router.navigate([url]);
  }
}
